import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAward,
  faCircleCheck,
  faComments,
  faFileSignature,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

import { QUESTION_CHAT_URL, SIGNUP_FORM_URL } from '../../../../config/links';
import { Pill } from '../../../../components/Pill/Pill';
import { Reveal } from '../../../../components/Reveal/Reveal';

import ui from '../../../../styles/ui.module.css';
import st from './Hero.module.css';

export function Hero() {
  const { scrollY } = useScroll();
  const parallaxY1 = useTransform(scrollY, [0, 900], [0, -70]);
  const parallaxY2 = useTransform(scrollY, [0, 900], [0, -110]);

  return (
    <section className={st.hero}>
      <div className={st.bg} aria-hidden="true">
        <motion.div className={`${st.orb} ${st.orbG}`} style={{ y: parallaxY1 }} />
        <motion.div className={`${st.orb} ${st.orbR}`} style={{ y: parallaxY2 }} />
        <div className={st.grid} />
      </div>

      <div className={`${ui.container} ${st.inner}`}>
        <Reveal>
          <div className={st.top}>
            <Pill icon={faAward}>Курс от ведущего медицинского университета России</Pill>
            <Pill icon={faUsers}>Для врачей, организаторов здравоохранения и ИТ-специалистов</Pill>
          </div>
        </Reveal>

        <Reveal delay={0.05}>
          <h1 className={ui.h1}>
            AI в здравоохранении.
            <span className={ui.h1Accent}> Лучшие практики</span>, сценарии внедрения, основы разработки
          </h1>
        </Reveal>

        <Reveal delay={0.1}>
          <p className={`${ui.p} ${st.lead}`}>
            Спикеры — реальные врачи, организаторы здравоохранения, ИТ-разработчики, академическое сообщество, представители
            регулятора и лидеры мнений. Цель курса — повысить эффективность применения ИИ-решений в медицине.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className={st.actionRow}>
            <div className={st.actionMain}>
              <div className={st.cta}>
                <a className={ui.btn} href={SIGNUP_FORM_URL} target="_blank" rel="noreferrer">
                  Записаться <FontAwesomeIcon icon={faFileSignature} />
                </a>
                <a className={`${ui.btn} ${ui.btnGhost}`} href={QUESTION_CHAT_URL} target="_blank" rel="noreferrer">
                  Задать вопрос <FontAwesomeIcon icon={faComments} />
                </a>
              </div>

              <div className={st.trustList}>
                <div className={st.trust}>
                  <FontAwesomeIcon icon={faCircleCheck} /> Фокус на внедрение, доверие и безопасность
                </div>
                <div className={st.trust}>
                  <FontAwesomeIcon icon={faCircleCheck} /> Минимум «воды» — максимум сценариев и практик
                </div>
                <div className={st.trust}>
                  <FontAwesomeIcon icon={faCircleCheck} /> Курс для клиник и для региональных проектов
                </div>
              </div>
            </div>

            <aside className={`${ui.card} ${st.enrollmentBanner}`} aria-label="Набор на ноябрь 2026">
              <div className={st.enrollmentBadge}>Набор открыт</div>
              <div className={st.enrollmentTitle}>Открыт набор на ноябрь 2026 г.</div>
              <p className={st.enrollmentText}>
                Успейте записаться на ближайший поток курса по искусственному интеллекту в здравоохранении.
              </p>
              <a className={`${ui.btn} ${st.enrollmentBtn}`} href={SIGNUP_FORM_URL} target="_blank" rel="noreferrer">
                Записаться <FontAwesomeIcon icon={faFileSignature} />
              </a>
            </aside>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

